import { render, staticRenderFns } from "./schj.vue?vue&type=template&id=2443c876&scoped=true&"
import script from "./schj.vue?vue&type=script&lang=js&"
export * from "./schj.vue?vue&type=script&lang=js&"
import style0 from "./schj.vue?vue&type=style&index=0&id=2443c876&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2443c876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2443c876')) {
      api.createRecord('2443c876', component.options)
    } else {
      api.reload('2443c876', component.options)
    }
    module.hot.accept("./schj.vue?vue&type=template&id=2443c876&scoped=true&", function () {
      api.rerender('2443c876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schj/schj.vue"
export default component.exports